import { UpdateUserPermissions } from '@modules/users';

export const UpdateUserPermissionsPage = () => {
  return <UpdateUserPermissions />;
};
